import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Tooltip,
  CircularProgress,
} from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import LienAvecVerification from "../../footer/LienAvecVerification";
import DOMPurify from "dompurify";
import rest from "../../../rest";
import useStylesThemes from "../../css/globalTheme";

const CharteModal = ({ open, onClose, onAccept, url, fallbackUrl }) => {
  const [canAccept, setCanAccept] = useState(false);
  const [texte, setTexte] = useState("");
  const [loading, setLoading] = useState(true);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const contentRef = useRef(null);
  const globalClasses = useStylesThemes()();

  useEffect(() => {
    if (open) {
      setCanAccept(false);
      setLoading(true);
      fetchCharteContent();
    }
  }, [open, url, fallbackUrl]);

  const fetchCharteContent = async () => {
    try {
      const response = await rest.post("/gestionTextes/detail.json", {
        titre: "CharteBenevole",
      });
      const sanitizedContent = DOMPurify.sanitize(response.data.contenu);
      setTexte(sanitizedContent);
    } catch (error) {
      console.error("Error fetching charte content:", error);
      setTexte("Impossible de charger le contenu de la charte.");
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const element = contentRef.current;
    if (element) {
      const isAtBottom =
        Math.abs(
          element.scrollHeight - element.scrollTop - element.clientHeight
        ) < 1;
      if (isAtBottom) {
        setCanAccept(true);
      }
    }
  };

  const handleClick = () => {
    setIsButtonDisabled(true);
    onAccept();
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 2000); // Réactive le bouton après 3 secondes
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="charte-dialog-title"
      fullWidth
      maxWidth="lg"
      className={globalClasses.modalStyle}
    >
      <DialogTitle
        id="charte-dialog-title"
        className={globalClasses.modalTitle}
      >
        Charte d'utilisation
      </DialogTitle>

      <DialogContent
        ref={contentRef}
        onScroll={handleScroll}
        style={{ maxHeight: "60vh", overflowY: "auto" }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: texte }} />
        )}
      </DialogContent>
      <DialogActions style={{ marginRight: 20 }}>
        <Button
          onClick={onClose}
          color="primary"
          className={globalClasses.secondarybutton}
        >
          Fermer
        </Button>
        <Button
          onClick={handleClick}
          color="primary"
          disabled={!canAccept || loading || isButtonDisabled}
          className={globalClasses.primarybutton}
        >
          {isButtonDisabled ? (
            <>
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
              <span style={{ visibility: "hidden" }}>J'ai lu et j'accepte</span>
            </>
          ) : (
            "J'ai lu et j'accepte"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const CharteBenevoleLink = ({ manifParams, classes, openModal }) => {
  return (
    <LienAvecVerification
      url={manifParams.CharteBenevole}
      label={
        <Tooltip title="Charte bénévoles" arrow>
          <DescriptionIcon onClick={openModal} />
        </Tooltip>
      }
      fallbackUrl={"/gtexte.html?titre=CharteBenevole"}
      classes={classes}
      footerLink="none"
      style={{
        position: "relative",
        zIndex: 1,
        marginLeft: -30,
      }}
      target={"_blank"}
    />
  );
};

export { CharteModal, CharteBenevoleLink };
export default CharteModal;
